import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const HealthInsuranceCardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  gap: 12px;
  .ant-form-item {
    width: 288px;
  }
  .health-insurance-id-file-field {
    width: 288px;
  }
  .ant-upload-list-item-card-actions {
    display: flex;
    & > button {
      padding: 0 20px;
      & > div {
        width: 15px;
      }
    }
  }
  .ant-form-item {
    @media ${DEVICES.sm} {
      width: 100%;
    }
  }
`;
